import {Injectable} from "@angular/core";
import {MyHttp} from "./http";
import {environment} from "../config/environment";

@Injectable()
export class ContractService {

  constructor(private http:MyHttp) {
  }

  get(contractId){
    return this.http.get(`${environment.API}/contracts/${contractId}`)
      .map(res => res.json());
  }

  check(type){
    return this.http.get(`${environment.API}/contracts/check/${type}`)
      .map(res => res.json())
      .map(res => res.contract);
  }

  latest(type){
    return this.http.get(`${environment.API}/contracts/latest/${type}`)
      .map(res => res.json());
  }

  accept(contractId, signature = null){
    let data = {};
    if(signature){
      data['signature'] = signature;
    }

    return this.http.post(`${environment.API}/contracts/${contractId}/accept`, JSON.stringify(data))
      .map(res => res.json());
  }
}



// WEBPACK FOOTER //
// ./src/app/core/contract.service.ts